import { useMemo, useState } from 'react'
import AtivoPatrimonialHttp from '../../../../../services/api/https/patrimonio/ativo-patrimonial.http'
import MovimentacaoRecebimentoHttp from '../../../../../services/api/https/patrimonio/movimentacao-recebimento.http'
import PatrimonioOwnerHttp from '../../../../../services/api/https/patrimonio/patrimonio-owner.http'
import { getTransportadoras } from '../../../../../services/api/https/registration/transportadora.http'
import { getVehiclesTransfer } from '../../../../../services/api/https/registration/veiculos-transferencia.http'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'
import { parseToMysqlFormat } from '../../../../../services/util/date.service'
import { errorHandler } from '../../../../../services/util/error.service'
import { DateTime } from 'luxon'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_VEHICLE: 'Adquirindo veículos de transferência',
  GET_TRANSPORTADORAS: 'Adquirindo transportadoras',
  GET_PATRIMONIO_OWNERS: 'Adquirindo donos de patrimonio',
  GET_PATRIMONIOS: 'Adquirindo patrimonios',
  SAVE_MOVIMENT: 'Salvando movimentação de recebimento',
  EDIT_MOVIMENT: 'Salvando edição na movimentação de recebimento',
  SUCCESS: 'Movimentação salva com sucesso',
}

const INITIAL_MOVIMENTACAO = {
  patrimonio_owner_id: 0,
  tp_id: 0,
  num_viagem: '',
  data_movimentacao: new Date(),
  veiculo_transferencia_id: 0,
  transportadora_id: 0,
  type: 'recebimento',
  observacoes: '',
}

const INITIAL_STATE = {
  movimentacao: { ...INITIAL_MOVIMENTACAO },
  updatedMovimentacao: null,
  selectedVehicle: null,
  selectedTransportadora: null,
  selectedOwner: null,
  patrimonios: [],
  vehicles: [],
  transportadoras: [],
  ownersPatrimonio: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useMovimentacaoRecebimentoModal() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const buildMovimentacao = (
      movimentacao,
      selectedTp,
      selectedVehicle,
      selectedOwner,
      selectedTransportadora,
      patrimonios,
    ) => {
      const { placa, nome_transportadora, ...movimentacaoRecebimento } = movimentacao
      return {
        ...movimentacaoRecebimento,
        patrimonios: patrimonios.map(patri => {
          if (!movimentacaoRecebimento.id) {
            return { patrimonio_ativo_id: patri.id, qte_total: Number(patri.qte_total) }
          }

          const patrimonio = movimentacaoRecebimento.patrimonios.find(
            p => p.patrimonio_ativo_id === patri.id,
          )

          if (patrimonio) {
            return {
              id: patrimonio.id,
              patrimonio_ativo_id: patri.id,
              qte_total: Number(patri.qte_total),
            }
          } else {
            return {
              patrimonio_ativo_id: patri.id,
              qte_total: Number(patri.qte_total),
            }
          }
        }),
        data_movimentacao: parseToMysqlFormat(movimentacao.data_movimentacao),
        tp_id: selectedTp,
        patrimonio_owner_id: selectedOwner.patrimonio_owner_id,
        transportadora_id: selectedTransportadora.id,
        veiculo_transferencia_id: selectedVehicle.id,
        created_by_user_id: getUsuarioInfo().id,
      }
    }

    const hasErrors = (
      selectedTp,
      selectedVehicle,
      selectedOwner,
      selectedTransportadora,
      patrimonios,
    ) => {
      let errorMessage = null
      if (selectedTp === 0) {
        errorMessage = 'Selecione um TP'
      } else if (!selectedVehicle) {
        errorMessage = 'Selecione um Veiculo'
      } else if (!selectedOwner) {
        errorMessage = 'Selecione um Dono de Patrimonio'
      } else if (!selectedTransportadora) {
        errorMessage = 'Selecione uma Transportadora'
      } else if (patrimonios.filter(p => Number(p.qte_total) > 0).length === 0) {
        errorMessage = 'É necessário que pelo menos um patrimonio tenha uma quantidade maior que 0'
      }
      setState(prevState => ({ ...prevState, errorMessage: errorMessage }))
      return !!errorMessage
    }

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events
      onInputChange(name, value) {
        setState(prevState => {
          prevState.movimentacao[name] = value
          return { ...prevState }
        })
      },

      saveMovimentacaoRecebimento(
        movimentacao,
        selectedTp,
        selectedVehicle,
        selectedOwner,
        selectedTransportadora,
        patrimonios,
      ) {
        if (
          !hasErrors(
            selectedTp,
            selectedVehicle,
            selectedOwner,
            selectedTransportadora,
            patrimonios,
          )
        ) {
          const buildedMovimentacao = buildMovimentacao(
            movimentacao,
            selectedTp,
            selectedVehicle,
            selectedOwner,
            selectedTransportadora,
            patrimonios,
          )
          if (movimentacao.id)
            MovimentacaoRecebimentoHttp.updateMovimentacao(buildedMovimentacao)
              .then(movimentacao =>
                setState(prevState => ({
                  ...prevState,
                  updatedMovimentacao: movimentacao,
                  loadingMessage: LOAD_MESSAGE.SUCCESS,
                })),
              )
              .catch(err =>
                setState(prevState => ({
                  ...prevState,
                  errorMessage: errorHandler(err),
                  loadingMessage: LOAD_MESSAGE.NONE,
                })),
              )
          else
            MovimentacaoRecebimentoHttp.saveMovimentacao(buildedMovimentacao)
              .then(movimentacao =>
                setState(prevState => ({
                  ...prevState,
                  updatedMovimentacao: movimentacao,
                  loadingMessage: LOAD_MESSAGE.SUCCESS,
                })),
              )
              .catch(err =>
                setState(prevState => ({
                  ...prevState,
                  errorMessage: errorHandler(err),
                  loadingMessage: LOAD_MESSAGE.NONE,
                })),
              )
        }
      },

      getVehicles(selectedTp) {
        getVehiclesTransfer(selectedTp)
          .then(vehicles =>
            setState(prevState => ({
              ...prevState,
              vehicles: vehicles,
              selectedVehicle: vehicles.find(
                v => v.id === prevState.movimentacao.veiculo_transferencia_id,
              ),
              loadingMessage: LOAD_MESSAGE.GET_TRANSPORTADORAS,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getTransportadoras(selectedTp) {
        getTransportadoras(selectedTp)
          .then(transportadoras =>
            setState(prevState => ({
              ...prevState,
              transportadoras: transportadoras,
              selectedTransportadora: transportadoras.find(
                t => t.id === prevState.movimentacao.transportadora_id,
              ),
              loadingMessage: LOAD_MESSAGE.GET_PATRIMONIO_OWNERS,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getPatrimonioOwners() {
        PatrimonioOwnerHttp.fetchOwnersByUserId(getUsuarioInfo().id)
          .then(owners => {
            setState(prevState => {
              prevState.ownersPatrimonio = owners
              const owner = owners.find(
                o => o.patrimonio_owner_id === prevState.movimentacao.patrimonio_owner_id,
              )
              prevState.selectedOwner = owner
              if (owner) {
                prevState.loadingMessage = LOAD_MESSAGE.GET_PATRIMONIOS
              } else prevState.loadingMessage = LOAD_MESSAGE.NONE
              return { ...prevState }
            })
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getPatrimonios(ownerId) {
        AtivoPatrimonialHttp.fetchAtivosByOwner(ownerId)
          .then(patrimonios =>
            setState(prevState => {
              if (prevState.movimentacao.patrimonios) {
                prevState.patrimonios = patrimonios.map(p => {
                  const patrimonio = prevState.movimentacao.patrimonios.find(
                    ptr => ptr.patrimonio_ativo_id === p.id,
                  )
                  if (patrimonio) return { ...p, qte_total: patrimonio.qte_total }
                  else return { ...p, qte_total: 0 }
                })
              } else {
                prevState.patrimonios = patrimonios
              }
              return { ...prevState, loadingMessage: LOAD_MESSAGE.NONE }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      onSelectedItemChange(item, value) {
        switch (item) {
          case 'vehicle':
            setState(prevState => ({ ...prevState, selectedVehicle: value }))
            break

          case 'transportadora':
            setState(prevState => ({ ...prevState, selectedTransportadora: value }))
            break

          case 'owner':
            setState(prevState => ({
              ...prevState,
              selectedOwner: value,
              loadingMessage: LOAD_MESSAGE.GET_PATRIMONIOS,
            }))
            break

          default:
            break
        }
      },

      onPatrimonioChange(patrimonio, quant) {
        setState(prevState => {
          const index = prevState.patrimonios.findIndex(patri => patri.id === patrimonio.id)
          if (index !== -1) {
            patrimonio.qte_total = quant
            prevState.patrimonios[index] = patrimonio
          }
          return { ...prevState }
        })
      },

      onInit(movimentacao) {
        if (movimentacao) {
          const dt = movimentacao.data_movimentacao
          movimentacao.data_movimentacao =
            typeof dt === 'string' ? DateTime.fromFormat(dt, 'dd/MM/yyyy').toJSDate() : new Date(dt)
          setState(prevState => ({
            ...prevState,
            patrimonios: [],
            movimentacao: movimentacao,
            loadingMessage: LOAD_MESSAGE.GET_VEHICLE,
          }))
        } else
          setState(prevState => ({
            ...prevState,
            patrimonios: [],
            movimentacao: { ...INITIAL_MOVIMENTACAO },
            loadingMessage: LOAD_MESSAGE.GET_VEHICLE,
          }))
      },

      onSalvarClick() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_MOVIMENT }))
      },
    }
  }, [])

  return { state, localDispatch }
}
